import React from 'react'
import { Modal, Button } from 'reactstrap';
import { DeleteAgreement } from './DeleteAgreement';
import { FormSelectSecctions } from './FormSelectSecctions';
import { UpdateStatusAgreemet } from './UpdateStatusAgreemet';
import { Dialog } from 'primereact/dialog';


export const ModalAgreement = (props) => {

    const {
        modal, modalTitle, toggle, method, loading,
        name_company, contract_number, validity, status,
        saveDelete,
        sections, selectSecctionsInput, listExamProfile,
        saveSelectExamProfile, handleSelect, handleSelectAll, saveUpdateStatus,
        confirmationDelete, isDelete, valueCode, setValueCode
    } = props;



    const dialogTheme = method === "updateStatus"
        ? "Global-dialog Global-blue Global-small-v"
        : ` seller-dialog seller-dialog seller-danger seller-small-v`;


    const icon = method === "updateStatus"
        ? <i className="fa fa-unlock-alt"></i>
        : <i className="fa fa-trash"></i>

    return (
        <Dialog
            visible={modal}
            modal
            closable={false}
            onHide={toggle}
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            {icon}
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {modalTitle}

                            </div>
                        </div>
                    </div>
                </div>
            }
            className={` ${dialogTheme}`}
            maskClassName="custom-total-mask"
            footer={
                <>
                    {
                        method === "updateStatus" && <Button
                            size="sm"
                            color="secondary"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveUpdateStatus}
                        >
                            Si, actualizar
                        </Button>
                    }
                    {
                        method === "delete" && <Button size="sm" color="secondary" onClick={() => isDelete ? saveDelete() : confirmationDelete()} className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}>
                            Si, eliminar
                        </Button>

                    }


                    <Button size="sm" color="danger" type="button" onClick={toggle}>
                        Cancelar
                    </Button>

                </>
            }

        >

            {
                method === "listSelectSections"
                    ? <FormSelectSecctions
                        {
                        ...{
                            toggle, loading, sections, selectSecctionsInput, listExamProfile, saveSelectExamProfile, handleSelect, handleSelectAll
                        }
                        }
                    />
                    : (method === "updateStatus")

                        ? <UpdateStatusAgreemet button="Si, actualizar" {...{ toggle, loading, name_company, contract_number, status, validity, saveUpdateStatus, }} />

                        : <DeleteAgreement {...{ toggle, loading, name_company, contract_number, validity, saveDelete, confirmationDelete, isDelete, valueCode, setValueCode }} />
            }
        </Dialog>
    )
}
